module.exports = __webpack_public_path__ + "img/logo_iam.b7c4c23a.webp";